if (!window.__productGalleryGridOverrideLoaded) {
  window.__productGalleryGridOverrideLoaded = true;

  const originalScrollIntoView = Element.prototype.scrollIntoView;

  const isGridGallery = (gallery) => {
    const carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return false;
    return Math.round(carousel.scrollWidth) === Math.round(carousel.clientWidth);
  };

  const moveMediaToFirstPosition = (galleryMedia) => {
    const gallery = galleryMedia.closest('product-gallery');
    if (!gallery) return;

    const carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    const currentScroll = window.scrollY;

    if (carousel.firstElementChild !== galleryMedia) {
      carousel.prepend(galleryMedia);
    }

    gallery.querySelectorAll('.product-gallery__media').forEach((media) => {
      media.classList.toggle('is-initial', media === galleryMedia);
    });

    gallery
      .querySelectorAll('.product-gallery__thumbnail-list .scroll-marker')
      .forEach((button) => {
        const thumbMediaId = button.dataset?.mediaId;
        if (!thumbMediaId) return;
        button.setAttribute('aria-current', thumbMediaId === galleryMedia.dataset.mediaId ? 'true' : 'false');
      });

    requestAnimationFrame(() => window.scrollTo({ top: currentScroll }));
  };

  Element.prototype.scrollIntoView = function scrollIntoViewOverride(options) {
    if (
      this?.classList?.contains('product-gallery__media') &&
      this.closest('product-gallery') &&
      isGridGallery(this.closest('product-gallery'))
    ) {
      moveMediaToFirstPosition(this);
      return;
    }

    return originalScrollIntoView.call(this, options);
  };

  document.addEventListener('shopify:section:load', () => {
    // le patch reste global, rien d’autre à faire mais l’écouteur garantit
    // que le script est initialisé pour les sections dynamiquement rechargées
  });
}
if (!window.__productGalleryGridOverrideLoaded) {
  window.__productGalleryGridOverrideLoaded = true;

  const originalScrollIntoView = Element.prototype.scrollIntoView;

  const isGridGallery = (gallery) => {
    const carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return false;
    return Math.round(carousel.scrollWidth) === Math.round(carousel.clientWidth);
  };

  const moveMediaToFirstPosition = (galleryMedia) => {
    const gallery = galleryMedia.closest('product-gallery');
    if (!gallery) return;

    const carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    const currentScroll = window.scrollY;

    if (carousel.firstElementChild !== galleryMedia) {
      carousel.prepend(galleryMedia);
    }

    gallery.querySelectorAll('.product-gallery__media').forEach((media) => {
      media.classList.toggle('is-initial', media === galleryMedia);
    });

    gallery
      .querySelectorAll('.product-gallery__thumbnail-list .scroll-marker')
      .forEach((button) => {
        const thumbMediaId = button.dataset?.mediaId;
        if (!thumbMediaId) return;
        button.setAttribute('aria-current', thumbMediaId === galleryMedia.dataset.mediaId ? 'true' : 'false');
      });

    requestAnimationFrame(() => window.scrollTo({ top: currentScroll }));
  };

  Element.prototype.scrollIntoView = function scrollIntoViewOverride(options) {
    if (
      this?.classList?.contains('product-gallery__media') &&
      this.closest('product-gallery') &&
      isGridGallery(this.closest('product-gallery'))
    ) {
      moveMediaToFirstPosition(this);
      return;
    }

    return originalScrollIntoView.call(this, options);
  };

  document.addEventListener('shopify:section:load', () => {
    // le patch reste global, rien d’autre à faire mais l’écouteur garantit
    // que le script est initialisé pour les sections dynamiquement rechargées
  });
}
